import { TRIP_RELOAD, TRIP_RELOADED } from '../../actions/trip_actions';

export default function(state = null, action){
    switch (action.type){
        case TRIP_RELOAD:
            return {trip_updated: true};
        case TRIP_RELOADED:
            return {trip_updated: false};
        default:
            break;
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/reducers/Trip/trip_reducer.js